import store from '@/store/index';
import utils from '@/utils/utils';

export default {
  /** 返回星期对应的文本表示 */
  formatWeekday(weekIndex = 0){
    const lanType = localStorage.getItem('lan_type') || 1;
    const weekArray = store.state.multiLanguage.weekDay[lanType - 1];

    return weekArray[Number(weekIndex)];
  },

  /** 截取格式为'2019-01-01或者2019/01/01格式日期的中的月份和日期 */
  filterMonthAndDay(date){
    if(!date){
      return '';
    }

    let dateArr = null;
    let target = '';

    if(date.indexOf('-') > -1){
      dateArr = date.split('-');
      target = `${dateArr[1]}-${dateArr[2]}`;
    }else{
      dateArr = date.split('/');
      target = `${dateArr[1]}/${dateArr[2]}`;
    }

    return target;
  },

  /** 将时间戳转为日期格式 */
  formatDateWithStamp(stamp, isFull = false, fmt = '-'){
    const oDate = new Date(stamp);
    const year = oDate.getFullYear();
    const month = oDate.getMonth() + 1;
    const date = oDate.getDate();
    let result = '';

    if(isFull){
      result = `${year}${fmt}${utils.zeroPad(month)}${fmt}${date}`;
    }else{
      result = `${utils.zeroPad(month)}${fmt}${utils.zeroPad(date)}`;
    }

    return result;
  },

  /** 格式化星期增强版 */
  formatWeekWithFullDate(date){
    const lanType = +localStorage.getItem('lan_type');
    let weekIdx = new Date(date).getDay();
    let weekStr = '';

    if(lanType === 1 && utils.checkDateIsToday(date) === 'today'){
      weekStr = '今天';
    }else if(lanType === 1 && utils.checkDateIsToday(date) === 'tomorrow'){
      weekStr = '明天';
    }else{
      weekStr = store.state.multiLanguage.weekDay[lanType - 1][weekIdx];
    }

    return weekStr;
  },

  /** 计算两个日期间的天数 */
  calcCycle(startDate, endDate){
    return utils.calcCycle(startDate, endDate);
  },

  /** 过滤搜索结果中的关键字，将关键字高亮显示 */
  formatKeyword(result, keyword){
    const reg = new RegExp(keyword);

    return result.replace(reg, `<span class="font-color-blue">${keyword}</span>`);
  },
}



// WEBPACK FOOTER //
// ./src/filters/filters.js